define('models/pages/wishlist/offers/filter-days',['require','underscore','chaplin','models/base/collection','lib/utils','./filter-day'],function(require) {
    'use strict';

    var _ = require('underscore'),
        Chaplin = require('chaplin'),
        Collection = require('models/base/collection'),
        utils = require('lib/utils'),
        FilterDay = require('./filter-day');

    var FilterDays = Collection.extend({
        model: FilterDay,
        initialize: function() {
            Chaplin.Collection.prototype.initialize.apply(this, arguments);
            _.extend(this, Chaplin.SyncMachine);
        },

        fill: function(items) {
            var found, update = {}, allCount = 0;

            var filter = this;

            filter.forEach(function(item) {

                found = items.findWhere(function(item) {
                    return item.get('date') === found.get('date') &&
                           item.get('month') === found.get('month') &&
                           item.get('year') === found.get('year');
                });

                if (found) {
                    update[item.cid] = item;
                }

                item.set('count', 0, { silent: true });
            });

            items.forEach(function(item) {
                found = filter.findWhere(item.get('filter'));
                if (found) {
                    update[found.cid] = found;
                    found.set('count', found.get('count')+1, { silent: true });
                }
                allCount++;
            });

            _.forEach(update, function(item) {
                item.trigger('change:count');
            });

            if (allCount) {
                filter.at(0).set('count', allCount);
            }
        },

        applyFilterTo: function(items) {

            var filter, found, foundItems = this.where({ active: true });

            if (foundItems[0] && foundItems[0].get('all')) { return items; }

            var result = [], item, i, li, j, lj;
            for (i=0,li=items.length;i<li;i++) {
                item = items[i];

                for (j=0,lj=foundItems.length;j<lj;j++) {
                    found = foundItems[j];
                    filter = item.filter;

                    if (
                        filter.date === found.get('date') &&
                        filter.month === found.get('month') &&
                        filter.year === found.get('year')
                    ) {
                        result.push(item);
                    }
                }
            }

            return result;
        }
    });

    FilterDays.generate = function() {
        var items = [{
            name: 'Все',
            count: 0,
            all: true,
            active: true
        }];

        var tmp, today = new Date();
        for (var i=0; i<7; i++) {
            tmp = new Date(today);
            tmp.setDate(today.getDate() + i);
            items.push({
                name  : utils.fmtDisplayDate(tmp, true).toLowerCase().split(' ').join('<br>'),
                count : 0,

                date  : tmp.getDate(),
                month : tmp.getMonth(),
                year  : tmp.getFullYear()
            });
        }
        return new FilterDays(items);
    };

    return FilterDays;
});

